import { Leaf, Recycle, Wind } from 'lucide-react';

export const LandingEco = () => {
    return (
        <section className="py-20 lg:py-28 bg-white border-t border-gray-100 overflow-hidden relative">
            <div className="max-w-[1440px] mx-auto px-6">
                <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">

                    {/* Content Side */}
                    <div className="w-full lg:w-1/2 animate-fade-in-left order-2 lg:order-1">
                        <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-[0.2em] mb-6">
                            <Leaf className="w-4 h-4" />
                            Clean Media Tech
                        </div>

                        <h2 className="text-4xl lg:text-6xl font-black tracking-tight leading-[1] mb-8 text-gray-900">
                            Zero Papel.<br />
                            <span className="text-green-600">100% Impacto.</span>
                        </h2>

                        <p className="text-lg lg:text-xl text-gray-600 mb-10 leading-relaxed font-medium">
                            Sua estratégia de marketing não precisa custar uma árvore.
                            Com a Watch, você elimina a logística poluente de impressão, transporte e descarte de materiais físicos.
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-3xl hover:bg-green-50/50 transition-colors">
                                <div className="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center flex-shrink-0 text-green-600">
                                    <Recycle className="w-6 h-6" />
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 mb-1">-100% Resíduos</h4>
                                    <p className="text-sm text-gray-500 font-medium">Fim dos banners de lona e panfletos que vão para o lixo.</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-3xl hover:bg-green-50/50 transition-colors">
                                <div className="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center flex-shrink-0 text-green-600">
                                    <Wind className="w-6 h-6" />
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 mb-1">Logística Limpa</h4>
                                    <p className="text-sm text-gray-500 font-medium">Troque campanhas em segundos, sem caminhões nas ruas.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Visual Side */}
                    <div className="w-full lg:w-1/2 order-1 lg:order-2 animate-fade-in-right">
                        <div className="relative">
                            {/* Green Glow */}
                            <div className="absolute inset-0 bg-green-500/10 blur-[100px] rounded-full" />

                            <div className="relative bg-gradient-to-br from-green-600 to-emerald-700 rounded-[40px] p-8 lg:p-12 border border-green-500/30 shadow-2xl overflow-hidden group">
                                {/* Decorative Pattern */}
                                <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -mr-32 -mt-32" />

                                <h3 className="text-3xl lg:text-4xl font-black text-white mb-2 relative z-10">O futuro da mídia é verde.</h3>
                                <p className="text-green-100 font-bold text-lg mb-4 relative z-10">Consciência Digital</p>
                                <p className="text-green-50 mb-8 max-w-sm relative z-10 font-medium opacity-90">
                                    A inovação que sua marca busca, com a responsabilidade que o mundo precisa.
                                </p>

                                {/* Abstract Representation of Nature vs Tech */}
                                <div className="relative h-[300px] lg:h-[400px] w-full rounded-2xl overflow-hidden shadow-lg">
                                    <img
                                        src="/images/wclean.webp"
                                        alt="Natureza e Tecnologia"
                                        className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                                    <div className="absolute bottom-6 left-6 text-white">
                                        <p className="font-bold text-lg">Sustentabilidade + Performance.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};
